export default __webpack_public_path__ + "f5d0128789c974d4a111ea0e6d4ecb40.png";